import {HttpHelper} from "../helpers/HttpHelper";
import {StorageHelper} from "../helpers/StorageHelper";
import {AppConfig} from "../helpers/AppConfig";

export default class LoginServicio {

    static login(usuario, contrasenya) {
        return new Promise((resolve, reject) => {
            let params = {
                email: usuario,
                password: contrasenya,
            };

            HttpHelper.post('auth/login', params)
                .then((res) => {
                    StorageHelper.put(AppConfig.TOKEN_CLAVE, res.token);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error)
                });
        });
    }

    static logout() {
        StorageHelper.delete(AppConfig.TOKEN_CLAVE);
    }
}